"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../../Grid"));
var index_1 = require("../index");
var Icon_1 = __importDefault(require("../../Icon"));
var CloseButton_1 = __importDefault(require("./CloseButton"));
var styles_1 = require("../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        icon: {
            position: 'relative',
            top: spacing(0.35)
        }
    });
});
var Notification = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.autoHideDuration, autoHideDuration = _c === void 0 ? 15000 : _c, onClose = _a.onClose, _d = _a.isError, isError = _d === void 0 ? false : _d, _e = _a.open, open = _e === void 0 ? false : _e, icon = _a.icon, classes = _a.classes;
    var internalClasses = useStyles();
    if (!text || !open)
        return null;
    return (react_1.default.createElement(index_1.Snackbar, { classes: classes, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, open: open, onClose: onClose, autoHideDuration: autoHideDuration, ContentProps: {
            'aria-describedby': 'message-id'
        }, message: react_1.default.createElement(Grid_1.default, { container: true, alignItems: "center" },
            icon && (react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Icon_1.default, { fontSize: "small", classes: { root: internalClasses.icon }, kind: icon }))),
            react_1.default.createElement(Grid_1.default, { item: true }, text)), action: react_1.default.createElement(CloseButton_1.default, { onClose: onClose, isError: isError }) }));
};
exports.default = Notification;
